export enum ExternalToolEnum {
  SLACK = 'SLACK',
  TEAMS = 'TEAMS',
  OTHER = 'OTHER',
  SPEACH = 'SPEACH',
  NONE = 'NONE'
}
